import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "bg-white rounded-lg shadow-md" }
const _hoisted_3 = { class: "p-4 border-b border-gray-200" }
const _hoisted_4 = { class: "mt-4 space-y-4" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = {
  class: "display table-striped table-hover table-bordered table",
  id: "basic-1"
}
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_14 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" }
const _hoisted_15 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_16 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_17 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_18 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_20 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_21 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_22 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_23 = ["onClick", "title"]
const _hoisted_24 = { class: "ml-1 text-xs" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_27 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_28 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "p-4 border-t border-gray-200" }
const _hoisted_33 = { class: "text-sm text-gray-600" }
const _hoisted_34 = {
  class: "modal fade",
  id: "rejectChangeModal",
  tabindex: "-1",
  "aria-labelledby": "rejectModalLabel",
  "aria-hidden": "true"
}
const _hoisted_35 = { class: "modal-dialog" }
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = { class: "modal-footer" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "gallery-header" }
const _hoisted_42 = { class: "gallery-title" }
const _hoisted_43 = { class: "counter" }
const _hoisted_44 = { class: "gallery-actions" }
const _hoisted_45 = ["title"]
const _hoisted_46 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_47 = {
  key: 1,
  class: "error-overlay"
}
const _hoisted_48 = ["src"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "zoom-controls" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "zoom-level" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 0,
  class: "gallery-thumbnails"
}
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["src", "alt"]
const _hoisted_59 = { class: "thumbnail-overlay" }

import { ref, onMounted, onUnmounted, computed } from 'vue'
import axios from 'axios'
import { Modal } from 'bootstrap'

// Interfaces
interface KytId {
  _id: string | null
  siteName?: string
  status?: string
  date?: string
}

interface EmpId {
  _id: string
  email: string
}

interface ChangeRequest {
  _id: string
  kytId: KytId | null
  kytLogNo: string
  siteName: string
  empId: EmpId
  empName: string
  reason: string
  date: string
  status: string
  createdAt: string
  updatedAt: string
  __v: number
  images: string[]
  initialNFD: string | null
  approvedBy: {
    _id: string
    name: string
    email: string
  } | null
  approvedAt: string | null
}

// Update the interface to use only client coordinates
interface PointerCoordinates {
  clientX: number;
  clientY: number;
}

// State

export default /*@__PURE__*/_defineComponent({
  __name: 'kyt-change',
  setup(__props) {

const changeRequests = ref<ChangeRequest[]>([])
const rejectReason = ref('')
const selectedRequestId = ref('')
const baseUrl = process.env.VUE_APP_BASE_URL
const token = localStorage.getItem('token')

// Gallery state
const showGallery = ref(false)
const isFullscreen = ref(false)
const isZoomed = ref(false)
const mainImage = ref<HTMLImageElement | null>(null)
const thumbnailsContainer = ref<HTMLElement | null>(null)
const galleryImages = ref<string[]>([])
const currentImageIndex = ref(0)
const isImageLoading = ref(true)
const imageError = ref(false)

// Touch handling state
const touchStartX = ref(0)
const touchStartY = ref(0)
const initialPinchDistance = ref(0)
const zoomLevel = ref(1)
const panPosition = ref({ x: 0, y: 0 })
const isPanning = ref(false)
const startPanPosition = ref({ x: 0, y: 0 })
const lastMousePosition = ref({ x: 0, y: 0 })

// Add filter states
const filters = ref({
  employeeName: '',
  siteName: '',
  startDate: '',
  endDate: ''
})

// Computed
const currentGalleryImage = computed(() => {
  return galleryImages.value[currentImageIndex.value] || ''
})

const containerStyle = computed(() => ({
  cursor: isPanning.value ? 'grabbing' : (zoomLevel.value > 1 ? 'grab' : 'default'),
  overflow: zoomLevel.value > 1 ? 'hidden' : 'visible'
}))

const imageStyle = computed(() => ({
  transform: `translate(${panPosition.value.x}px, ${panPosition.value.y}px) scale(${zoomLevel.value})`,
  opacity: isImageLoading.value ? 0 : 1
}))

// Add computed property for filtered requests
const filteredRequests = computed(() => {
  return changeRequests.value.filter(request => {
    const matchesEmployeeName = !filters.value.employeeName || 
      request.empName.toLowerCase().includes(filters.value.employeeName.toLowerCase())
    
    const matchesSiteName = !filters.value.siteName || 
      request.siteName.toLowerCase().includes(filters.value.siteName.toLowerCase())
    
    const requestDate = new Date(request.date)
    const startDate = filters.value.startDate ? new Date(filters.value.startDate) : null
    const endDate = filters.value.endDate ? new Date(filters.value.endDate) : null
    
    const matchesDateRange = (!startDate || requestDate >= startDate) && 
      (!endDate || requestDate <= new Date(endDate.setHours(23, 59, 59, 999)))
    
    return matchesEmployeeName && matchesSiteName && matchesDateRange
  })
})

// Methods
const fetchChangeRequests = async () => {
  try {
    const response = await axios.get(`${baseUrl}api/operation/kyt/change-requests`)
    if (response.data.success) {
      changeRequests.value = response.data.data
    }
  } catch (error) {
    console.error('Error fetching change requests:', error)
    alert('Error fetching change requests')
  }
}

const handleApprove = async (requestId: string) => {
  try {
    const response = await axios.put(
      `${baseUrl}api/operation/kyt/change-requests/approve/${requestId}`,
      {}, // Empty body
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    )
    if (response.data.success) {
      alert('Change request approved successfully')
      await fetchChangeRequests()
    }
  } catch (error: any) {
    console.error('Error approving request:', error)
    alert(error.response?.data?.message || 'Error approving request')
  }
}

const openRejectModal = (requestId: string) => {
  selectedRequestId.value = requestId
  rejectReason.value = ''
  rejectModal?.show()
}

const handleReject = async () => {
  if (!rejectReason.value) {
    alert('Please provide a reason for rejection')
    return
  }

  try {
    const response = await axios.put(
      `${baseUrl}api/operation/kyt/change-requests/reject/${selectedRequestId.value}`,
      { reason: rejectReason.value }
    )
    if (response.data.success) {
      alert('Change request rejected successfully')
      rejectModal?.hide()
      await fetchChangeRequests()
    }
  } catch (error: any) {
    console.error('Error rejecting request:', error)
    alert(error.response?.data?.message || 'Error rejecting request')
  }
}

const formatDate = (dateString: string | null) => {
  if (!dateString) return '-'
  
  try {
    let date: Date;
    
    // Handle simple DD-MM-YYYY format
    if (dateString.includes('-') && dateString.split('-').length === 3 && !dateString.includes('T')) {
      const [day, month, year] = dateString.split('-')
      date = new Date(`${year}-${month}-${day}`)
    }
    // Handle ISO format
    else if (dateString.includes('T')) {
      date = new Date(dateString)
    }
    // Handle full datetime string
    else {
      date = new Date(dateString)
    }

    if (isNaN(date.getTime())) return dateString // Return original if parsing fails

    // Format to DD-MM-YYYY
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()

    return `${day}-${month}-${year}`
  } catch (error) {
    console.error('Error formatting date:', error)
    return dateString // Return original string if formatting fails
  }
}

// Gallery methods
const openGallery = (images: string[], startIndex: number = 0) => {
  galleryImages.value = images
  currentImageIndex.value = startIndex
  isImageLoading.value = true
  imageError.value = false
  showGallery.value = true
  resetZoom()
}

const closeGallery = () => {
  showGallery.value = false
  resetZoom()
}

const toggleFullscreen = async () => {
  try {
    if (!isFullscreen.value) {
      await document.documentElement.requestFullscreen()
      isFullscreen.value = true
    } else {
      await document.exitFullscreen()
      isFullscreen.value = false
    }
  } catch (error) {
    console.error('Fullscreen error:', error)
  }
}

const handleImageLoad = () => {
  isImageLoading.value = false
  imageError.value = false
}

const handleImageError = () => {
  isImageLoading.value = false
  imageError.value = true
}

const reloadImage = () => {
  isImageLoading.value = true
  imageError.value = false
  const currentImage = galleryImages.value[currentImageIndex.value]
  galleryImages.value[currentImageIndex.value] = `${currentImage}?t=${Date.now()}`
}

// Navigation methods
const nextImage = () => {
  if (isImageLoading.value) return
  isImageLoading.value = true
  imageError.value = false
  resetZoom()
  if (currentImageIndex.value < galleryImages.value.length - 1) {
    currentImageIndex.value++
  } else {
    currentImageIndex.value = 0
  }
}

const previousImage = () => {
  if (isImageLoading.value) return
  isImageLoading.value = true
  imageError.value = false
  resetZoom()
  if (currentImageIndex.value > 0) {
    currentImageIndex.value--
  } else {
    currentImageIndex.value = galleryImages.value.length - 1
  }
}

const selectImage = (index: number) => {
  isImageLoading.value = true
  imageError.value = false
  currentImageIndex.value = index
  resetZoom()
}

// Zoom and pan methods
const handleZoom = (event: WheelEvent) => {
  if (isImageLoading.value) return
  
  const delta = event.deltaY * -0.01
  const newZoom = Math.max(1, Math.min(5, zoomLevel.value + delta))
  
  if (newZoom !== zoomLevel.value) {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect()
    const x = event.clientX - rect.left
    const y = event.clientY - rect.top
    
    const scale = newZoom / zoomLevel.value
    
    panPosition.value = {
      x: x - (x - panPosition.value.x) * scale,
      y: y - (y - panPosition.value.y) * scale
    }
    
    zoomLevel.value = newZoom
  }
}

const zoomIn = () => {
  if (zoomLevel.value < 5) {
    zoomLevel.value += 0.5
  }
}

const zoomOut = () => {
  if (zoomLevel.value > 1) {
    zoomLevel.value -= 0.5
  }
}

const resetZoom = () => {
  zoomLevel.value = 1
  panPosition.value = { x: 0, y: 0 }
}

// Update the pan handlers to use only client coordinates
const startPan = (event: MouseEvent | PointerCoordinates) => {
  if (zoomLevel.value > 1) {
    isPanning.value = true
    lastMousePosition.value = { 
      x: event.clientX,
      y: event.clientY
    }
    startPanPosition.value = { ...panPosition.value }
  }
}

const pan = (event: MouseEvent | PointerCoordinates) => {
  if (!isPanning.value) return
  
  const deltaX = event.clientX - lastMousePosition.value.x
  const deltaY = event.clientY - lastMousePosition.value.y
  
  panPosition.value = {
    x: startPanPosition.value.x + deltaX,
    y: startPanPosition.value.y + deltaY
  }
}

const stopPan = () => {
  isPanning.value = false
}

const handleTouchStart = (event: TouchEvent) => {
  if (event.touches.length === 2) {
    // Pinch to zoom
    const touch1 = event.touches[0]
    const touch2 = event.touches[1]
    initialPinchDistance.value = Math.hypot(
      touch2.clientX - touch1.clientX,
      touch2.clientY - touch1.clientY
    )
  } else if (event.touches.length === 1) {
    // Single touch for panning
    const touch = event.touches[0]
    touchStartX.value = touch.clientX
    touchStartY.value = touch.clientY
    if (zoomLevel.value > 1) {
      startPan({
        clientX: touch.clientX,
        clientY: touch.clientY
      })
    }
  }
}

const handleTouchMove = (event: TouchEvent) => {
  if (event.touches.length === 2) {
    // Handle pinch zoom
    const touch1 = event.touches[0]
    const touch2 = event.touches[1]
    const currentDistance = Math.hypot(
      touch2.clientX - touch1.clientX,
      touch2.clientY - touch1.clientY
    )
    
    const scale = currentDistance / initialPinchDistance.value
    const newZoom = Math.max(1, Math.min(5, zoomLevel.value * scale))
    
    if (newZoom !== zoomLevel.value) {
      zoomLevel.value = newZoom
    }
    
    initialPinchDistance.value = currentDistance
  } else if (event.touches.length === 1 && isPanning.value) {
    // Handle pan
    const touch = event.touches[0]
    pan({
      clientX: touch.clientX,
      clientY: touch.clientY
    })
  }
}

const handleTouchEnd = () => {
  stopPan()
  initialPinchDistance.value = 0
}

// Keyboard navigation
const handleKeyPress = (e: KeyboardEvent) => {
  if (!showGallery.value) return
  
  switch (e.key) {
    case 'ArrowLeft':
      previousImage()
      break
    case 'ArrowRight':
      nextImage()
      break
    case 'Escape':
      if (!isFullscreen.value) {
        closeGallery()
      }
      break
  }
}

// Lifecycle hooks
let rejectModal: any = null

onMounted(() => {
  fetchChangeRequests()
  rejectModal = new Modal(document.getElementById('rejectChangeModal'))
  
  window.addEventListener('keydown', handleKeyPress)
  document.addEventListener('fullscreenchange', () => {
    isFullscreen.value = !!document.fullscreenElement
  })
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyPress)
  document.removeEventListener('fullscreenchange', () => {})
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-xl font-semibold text-gray-800" }, "KYT Change Requests", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Employee Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.employeeName) = $event)),
                class: "form-control",
                placeholder: "Search by employee name"
              }, null, 512), [
                [_vModelText, filters.value.employeeName]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Site Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.siteName) = $event)),
                class: "form-control",
                placeholder: "Search by site name"
              }, null, 512), [
                [_vModelText, filters.value.siteName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Start Date", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.startDate) = $event)),
                class: "form-control"
              }, null, 512), [
                [_vModelText, filters.value.startDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "End Date", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.endDate) = $event)),
                class: "form-control"
              }, null, 512), [
                [_vModelText, filters.value.endDate]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", _hoisted_12, [
          _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Sl No."),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "KYT Log No"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Site Name"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Employee Name"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Status"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Reason"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Change Date"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Initial Date"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Images"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Approved By"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Approved At"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRequests.value, (request, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: request._id,
                class: "hover:bg-gray-50"
              }, [
                _createElementVNode("td", _hoisted_13, _toDisplayString(index + 1), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(request.kytLogNo), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(request.siteName), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(request.empName), 1),
                _createElementVNode("td", _hoisted_17, [
                  _createElementVNode("span", {
                    class: _normalizeClass({
                  'px-2 py-1 text-xs font-semibold rounded-full text-black': true,
                  'bg-yellow-100': request.status === 'Pending',
                  'bg-green-100': request.status === 'Approved',
                  'bg-red-100': request.status === 'Rejected'
                })
                  }, _toDisplayString(request.status), 3)
                ]),
                _createElementVNode("td", _hoisted_18, _toDisplayString(request.reason), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(formatDate(request.date)), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(request.initialNFD ? formatDate(request.initialNFD) : '-'), 1),
                _createElementVNode("td", _hoisted_21, [
                  (request.images && request.images.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (openGallery(request.images)),
                          class: "btn btn-light btn-sm",
                          title: `View ${request.images.length} Image${request.images.length > 1 ? 's' : ''}`
                        }, [
                          _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fa fa-images" }, null, -1)),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(request.images.length), 1)
                        ], 8, _hoisted_23)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
                ]),
                _createElementVNode("td", _hoisted_26, _toDisplayString(request.approvedBy?.name || '-'), 1),
                _createElementVNode("td", _hoisted_27, _toDisplayString(formatDate(request.approvedAt)), 1),
                _createElementVNode("td", _hoisted_28, [
                  (request.status === 'Pending')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (handleApprove(request._id)),
                        class: "btn btn-success btn-sm"
                      }, " Approve ", 8, _hoisted_29))
                    : _createCommentVNode("", true),
                  (request.status === 'Pending')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: ($event: any) => (openRejectModal(request._id)),
                        class: "btn btn-danger btn-sm"
                      }, " Reject ", 8, _hoisted_30))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            (filteredRequests.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("td", {
                    colspan: "12",
                    class: "text-center py-4 text-muted"
                  }, "No change requests found", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("p", _hoisted_33, " Showing " + _toDisplayString(filteredRequests.value.length) + " of " + _toDisplayString(changeRequests.value.length) + " total requests ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", {
              class: "modal-title",
              id: "rejectModalLabel"
            }, "Reject Change Request"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _cache[13] || (_cache[13] = _createElementVNode("label", {
                for: "rejectReason",
                class: "form-label"
              }, "Reason for Rejection", -1)),
              _withDirectives(_createElementVNode("textarea", {
                id: "rejectReason",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rejectReason).value = $event)),
                class: "form-control",
                rows: "3",
                placeholder: "Enter reason for rejection",
                required: ""
              }, null, 512), [
                [_vModelText, rejectReason.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _cache[14] || (_cache[14] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Cancel", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: handleReject,
              disabled: !rejectReason.value
            }, " Reject ", 8, _hoisted_40)
          ])
        ])
      ])
    ]),
    (showGallery.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "image-gallery-modal",
          onClick: _withModifiers(closeGallery, ["self"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["gallery-content", { 'is-zoomed': isZoomed.value }])
          }, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "title" }, "Image Gallery", -1)),
                _createElementVNode("span", _hoisted_43, _toDisplayString(currentImageIndex.value + 1) + " / " + _toDisplayString(galleryImages.value.length), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  class: "action-btn",
                  onClick: toggleFullscreen,
                  title: isFullscreen.value ? 'Exit Fullscreen' : 'Enter Fullscreen'
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(isFullscreen.value ? 'fa fa-compress' : 'fa fa-expand')
                  }, null, 2)
                ], 8, _hoisted_45),
                _createElementVNode("button", {
                  class: "action-btn",
                  onClick: closeGallery
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                ]))])
              ])
            ]),
            _createElementVNode("div", {
              class: "gallery-main",
              onWheel: _withModifiers(handleZoom, ["prevent"]),
              onMousedown: startPan,
              onMousemove: pan,
              onMouseup: stopPan,
              onMouseleave: stopPan,
              onTouchstart: handleTouchStart,
              onTouchmove: handleTouchMove,
              onTouchend: handleTouchEnd
            }, [
              (isImageLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("div", { class: "loader" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              (imageError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", { class: "error-message" }, [
                      _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa fa-exclamation-circle" }, null, -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("span", null, "Failed to load image", -1)),
                      _createElementVNode("button", {
                        class: "retry-btn",
                        onClick: reloadImage
                      }, "Retry")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "image-container",
                style: _normalizeStyle(containerStyle.value)
              }, [
                _createElementVNode("img", {
                  ref_key: "mainImage",
                  ref: mainImage,
                  src: currentGalleryImage.value,
                  class: _normalizeClass(['main-image', { 'loading': isImageLoading.value }]),
                  style: _normalizeStyle(imageStyle.value),
                  onLoad: handleImageLoad,
                  onError: handleImageError,
                  draggable: "false",
                  alt: "Gallery Image"
                }, null, 46, _hoisted_48)
              ], 4),
              (galleryImages.value.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "nav-btn prev",
                    onClick: previousImage,
                    disabled: isImageLoading.value
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
                  ]))], 8, _hoisted_49))
                : _createCommentVNode("", true),
              (galleryImages.value.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "nav-btn next",
                    onClick: nextImage,
                    disabled: isImageLoading.value
                  }, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
                  ]))], 8, _hoisted_50))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("button", {
                  class: "zoom-btn",
                  onClick: zoomOut,
                  disabled: zoomLevel.value <= 1
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "fa fa-search-minus" }, null, -1)
                ]))], 8, _hoisted_52),
                _createElementVNode("span", _hoisted_53, _toDisplayString(Math.round(zoomLevel.value * 100)) + "%", 1),
                _createElementVNode("button", {
                  class: "zoom-btn",
                  onClick: zoomIn,
                  disabled: zoomLevel.value >= 5
                }, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("i", { class: "fa fa-search-plus" }, null, -1)
                ]))], 8, _hoisted_54),
                _createElementVNode("button", {
                  class: "zoom-btn",
                  onClick: resetZoom,
                  disabled: zoomLevel.value === 1
                }, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("i", { class: "fa fa-undo" }, null, -1)
                ]))], 8, _hoisted_55)
              ])
            ], 32),
            (galleryImages.value.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("div", {
                    class: "thumbnails-scroll",
                    ref_key: "thumbnailsContainer",
                    ref: thumbnailsContainer
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(galleryImages.value, (image, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["thumbnail-item", { active: currentImageIndex.value === index }]),
                        onClick: ($event: any) => (selectImage(index))
                      }, [
                        _createElementVNode("img", {
                          src: image,
                          alt: 'Thumbnail ' + (index + 1),
                          loading: "lazy"
                        }, null, 8, _hoisted_58),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("span", null, _toDisplayString(index + 1), 1)
                        ])
                      ], 10, _hoisted_57))
                    }), 128))
                  ], 512)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})